<template>
  <div
    :style="{
      background: viewType === 'grid' || 'list' ? 'white' : 'whitesmoke',
    }"
  >
    <div :class="cartData.length > 0 ? 'main-container' : 'product-container'">
      <div class="d-flex justify-between align-items-center pt-4">
        <div class="text-bold" :style="'font-size: 22px;'">Select Products</div>
        <div class="mt-n10">
          <q-btn
            flat
            :class="getViewTypeClass('grid')"
            class="ml-9 pl-0 grid-btn"
            @click="viewType = 'grid'"
            label="Grid"
          >
            <div class="grid-img">
              <img
                v-if="viewType === 'grid'"
                src="/Grid_White.png"
              />
              <img v-else src="/Grid_Blue.png" />
            </div>
          </q-btn>
          <q-btn
            flat
            :class="getViewTypeClass('list')"
            class="ml-9 pl-0 list-btn"
            @click="viewType = 'list'"
            label="List"
          >
            <div class="list-img">
              <img
                v-if="viewType === 'list'"
                src="/List_White.png"
              />
              <img v-else src="/List_Blue.png" />
            </div>
          </q-btn>
        </div>
      </div>

      <div v-if="viewType === 'list'" class="grid-layout">
        <div
          class="list-contents mt-4"
          :class="cartData.length > 0 ? '' : 'flex-grow'"
        >
          <div
            v-for="(group, index) in groupedProducts"
            :key="'group-' + index"
            class="product-group-grid"
          >
            <h3
              :style="{
                color: '#105992',
                marginBottom: '15px',
                color: 222222,
                fontSize: '22px',
                fontWeight: 'bold',
                lineHeight: '25px',
              }"
            >
              {{ group.productLineName }}
            </h3>
            <div
              v-for="(product, pIndex) in group.products"
              :key="`group-${index}-product-${pIndex}`"
            >
              <q-card
                class="mb-2 mt-1 cursor-pointer"
                :class="{ 'q-card-section--vert': false }"
                @click="openOrderDetail(product)"
                flat
              >
                <div class="d-flex justify-center">
                  <div
                    class="row d-flex"
                    :style="'align-items: center; padding: 10px; width: 100%;'"
                  >
                    <div
                      class="col-2"
                      :style="'height: 140px; width: 140px; position: relative; display: inline-block;'"
                    >
                      <div class="col-2 image-container">
                        <img
                          :src="imageUrl(product.images)"
                          @click="openOrderDetail(product)"
                          class="cursor-pointer"
                        />
                      </div>

                      <div
                        v-if="product.tag?.toLowerCase() == 'most popular'"
                        class="overlay-text"
                      >
                        <span :style="'background-color: #F16565;'"
                          >Most Popular</span
                        >
                      </div>
                    </div>
                    <div class="col-9 mt-2">
                      <div class="ml-5 d-flex justify-between">
                        <span
                          class="text-bold"
                          :style="'font-size: 18px; color: #105992; line-height: 40px;'"
                          >{{ product.name }}</span
                        >
                      </div>
                      <div class="mx-5 my-1 mr-5 pr-5 d-flex">
                        <div>
                          <span
                            :style="'font-size: 15px; line-height: 1.5rem; color: #9e9e9e'"
                            class="text-grey text-bold"
                            >{{ product.productLineName }}
                          </span>
                        </div>
                        <div>
                          <span
                            class="ml-5"
                            :style="'color: #9e9e9e; font-size: 16px;'"
                          >
                            Rs. {{ getPriceData(product) }}/Unit
                          </span>
                        </div>
                      </div>
                      <div
                        class="mr-5 mx-5 text-bold my-2"
                        :style="'color: #388E3C; font-size: 14px;'"
                      >
                        <span class=""
                          >You are saving
                          {{
                            (product.mrp *
                              (product.quantity == 0 ? 1 : product.quantity) -
                              getPriceData(product) *
                                (product.quantity == 0 ? 1 : product.quantity))
                              | currencyFilter
                          }}</span
                        >
                      </div>
                      <div class="mx-5 d-flex justify-content-between">
                        <div class="d-flex mt-2">
                          <div>
                            <span
                              class="text-bold"
                              :style="'font-size: 20px; color: #044b9a'"
                            >
                              {{
                                Number(
                                  getPriceData(product) *
                                    (product.quantity == 0
                                      ? 1
                                      : product.quantity)
                                ) | currencyFilter
                              }}
                            </span>
                          </div>
                          <div :style="'margin-top: 1px!important;'">
                            <span
                              class="mrp-value ml-2 text-grey"
                              :style="'font-size: 17px; text-decoration: line-through; color: #9e9e9e'"
                            >
                              {{
                                (Number(product.mrp) *
                                  (product.quantity == 0
                                    ? 1
                                    : product.quantity))
                                  | currencyFilter
                              }}
                            </span>
                          </div>
                          <div class="mt-1">
                            <span
                              class="text-price-value ml-2"
                              :style="'font-size: 15px; color: #108f55;'"
                            >
                              {{ getPercentageData(product) }}% Off
                            </span>
                          </div>
                        </div>
                        <div class="d-flex">
                          <q-btn
                            flat
                            @click.stop="decreaseQuantity(product)"
                            class="mr-3 pd-btn minus-grid"
                            :disabled="product.quantity == 0"
                            icon="remove"
                          />
                          <div class="mr-3" :style="''">
                            <div class="">
                              <input
                                v-model="product.quantity"
                                @input="handleInput(product)"
                                class="square-list"
                                :min="0"
                                :max="product.maxPurchaseLimit"
                                @click.stop
                              />
                            </div>
                          </div>
                          <q-btn
                            flat
                            @click.stop="increaseQuantity(product)"
                            :disabled="disableIncrementButton(product)"
                            class="pd-btn plus-grid plus-grid-label"
                            icon="add"
                          />
                          <q-btn
                            @click.stop="addToCart(product)"
                            :disabled="disableAddButton(product)"
                            outline
                            class="add-cart custom-outline-btn ml-4"
                          >
                            Add to Cart
                          </q-btn>
                        </div>
                      </div>

                      <div class="mx-5 mt-3">
                        <div
                          v-if="inBagQuantity(product) > 0"
                          class="mt-2 text-red"
                        >
                          <p>
                            - Already added
                            {{ inBagQuantity(product) }} Quantity in Bag for
                            this Product.
                          </p>
                        </div>
                        <div
                          v-if="warningMaxLimit(product)"
                          class="mt-2 text-red"
                        >
                          <p>{{ warningMaxLimit(product) }}</p>
                        </div>
                        <div
                          v-if="
                            product.quantity > product.maxPurchaseLimit &&
                            !warningMaxLimit(product)
                          "
                          class="mt-2 text-red"
                        >
                          <p>
                            - Please Add {{ product.maxPurchaseLimit }} or Less
                            Quantities for this Product.
                          </p>
                        </div>
                      </div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </q-card>
            </div>
          </div>
          <div v-if="isLoading">
            <div class="row justify-center q-my-md">
              <q-spinner-dots color="primary" size="40px" />
            </div>
          </div>
        </div>
        <div
          v-if="cartData.length > 0"
          :class="cartData.length > 0 ? 'flex-shrink-1 cart-summary-sticky' : ''"
        >
          <q-card
            v-if="cartData.length > 0"
            class="mb-3 mt-4 mr-15 cart-summary"
          >
            <div class="text-center p-3" :style="'background: #044b9a1a'">
              <span
                class="text-bold font-family mt-2"
                :style="'font-size:22px; color: #044B9A'"
                >Cart Summary</span
              >
            </div>
            <q-card-section
              v-if="cartData.length > 0"
              :style="'background: #044b9a1a'"
            >
              <div>
                <div class="">
                  <div class="d-flex mt-2 justify-between mx-2">
                    <h6 class="font-family font-text-size">Order Total</h6>
                    <h6
                      class="font-text-size"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ (payableTotal + savingTotal) | currencyFilter }}
                    </h6>
                  </div>
                  <q-separator class="my-2" />
                  <div class="d-flex mt-2 justify-between mx-2">
                    <h6 class="font-family font-text-size">
                      Your Savings
                      <span
                        class="font-text-size text-bold"
                        :style="'color: #388E3C;'"
                        >({{ savingPercentage }}%)</span
                      >
                    </h6>
                    <h6
                      class="font-text-size"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ savingTotal | currencyFilter }}
                    </h6>
                  </div>
                  <q-separator class="my-2" />
                  <div class="d-flex mt-2 justify-between mx-2">
                    <h6 class="font-family font-text-size">Order Amount</h6>
                    <h6
                      class="font-text-size"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ payableTotal | currencyFilter }}
                    </h6>
                  </div>
                  <q-separator class="my-2" />
                  <div
                    v-if="gstColumn"
                    class="d-flex mt-2 justify-between mx-2"
                  >
                    <h6 class="font-family font-text-size">
                      SGST Amount <span class="font-text-size">(9%)</span>
                    </h6>
                    <h6
                      class="font-text-size"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ gstCount("sgst") | currencyFilter }}
                    </h6>
                  </div>
                  <div
                    v-if="gstColumn"
                    class="d-flex mt-2 justify-between mx-2"
                  >
                    <h6 class="font-family font-text-size">
                      CGST Amount <span class="font-text-size">(9%)</span>
                    </h6>
                    <h6
                      class="font-text-size"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ gstCount("cgst") | currencyFilter }}
                    </h6>
                  </div>
                  <div
                    v-if="!gstColumn"
                    class="d-flex mt-2 justify-between mx-2"
                  >
                    <h6 class="font-family font-text-size">
                      IGST Amount <span class="font-text-size">(18%)</span>
                    </h6>
                    <h6
                      class="font-text-size"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ gstCount("igst") | currencyFilter }}
                    </h6>
                  </div>

                  <q-separator class="my-2" />
                  <div class="d-flex mt-2 justify-between mx-2">
                    <h6 class="text-black font-text-size">Total Amount</h6>
                    <h6
                      class="font-text-size"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ payableTotalAmount() | currencyFilter }}
                    </h6>
                  </div>
                  <div class="d-flex mt-2 justify-between mx-2">
                    <h6 class="text-black font-text-size">Rounded Amount</h6>
                    <h6
                      class="font-text-size"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ sign() }} {{ roundedAmount() | currencyFilter }}
                    </h6>
                  </div>
                  <q-separator class="my-2" />
                  <div class="d-flex mt-2 justify-between mx-2">
                    <h6 class="text-black text-bold font-text-size">
                      Payable Amount
                    </h6>
                    <h6
                      class="font-text-size"
                      :style="'-webkit-text-stroke-width: medium; color: #167E85; font-size:18px'"
                    >
                      {{ payableAmount() | currencyFilter }}
                    </h6>
                  </div>
                  <q-separator class="my-2" />
                  <div class="mx-4 mt-4 text-center">
                    <span
                      class="font-family text-bold text-grey"
                      style="font-size: 13px"
                    >
                      *Click on “View Cart” and complete email verification and
                      payment process.
                    </span>
                  </div>
                  <div class="mt-3 text-center mx-2">
                    <q-btn
                      @click="$router.push('/Partners/Stock/Cart')"
                      class="mt-3 view-cart-list"
                      no-caps
                      :style="'background-color: #105992; width: 200px;'"
                    >
                      <q-img
                        :src="'/whiteBag.png'"
                        :style="'width:20px; height: 20px;'"
                      />
                      <span
                        class="ml-4 text-bold text-white font-family"
                        :style="'font-size: 18px; letter-spacing: 1px;'"
                      >
                        View Cart
                      </span>
                    </q-btn>
                  </div>
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>

    <!-- Grid View Start -->

    <div
      :class="
        cartData.length > 0 ? 'main-container mb-4' : 'product-container mb-4'
      "
      v-if="viewType === 'grid'"
    >
      <div class="grid-layout">
        <div
          class="grid-contents mt-4"
          :class="cartData.length > 0 ? '' : 'flex-grow'"
        >
          <div
            v-for="(group, index) in groupedProducts"
            :key="index"
            class="product-group"
          >
            <h3
              :style="{
                color: '#105992',
                marginBottom: '15px',
                color: 222222,
                fontSize: '22px',
                fontWeight: 'bold',
                lineHeight: '25px',
              }"
            >
              {{ group.productLineName }}
            </h3>
            <div class="cart-items">
              <div
                v-for="(product, pIndex) in group.products"
                :key="`group-${index}-product-${pIndex}`"
              >
                <q-card
                  class="cursor-pointer my-cart"
                  @click="openOrderDetail(product)"
                >
                  <div
                    class="q-card__section q-card__section--vert position-relative"
                  >
                    <div class="image-container-grid">
                      <img
                        :src="imageUrl(product.images)"
                        @click.stop
                        class="cursor-pointer"
                        @click="openOrderDetail(product)"
                      />
                    </div>
                    <div class="d-flex flex-column">
                      <div
                      class="text-bold mt-2"
                      style="font-size: 15px; color: #000000; cursor: pointer"
                     @mouseover="showTooltipData(product.id)"
                      @mouseleave="hideTooltip(product.id)"

                        >
                        {{ product.name.length> 30 ? product.name.substring(0, 25) + "..."
                         : product.name }}
                          <q-tooltip bg-color="deep-orange-5"
                          v-if="tooltipVisibility && product.name.length > 30"
                          anchor="bottom middle" self="top middle"
                      >
                      {{ product.name }}
                    </q-tooltip>
                        </div>
                      <div>
                        <div
                          style="font-size: 12px; color: #9e9e9e"
                          class="mt-0"
                        >
                          {{ product.productLineName }}
                        </div>
                        <div
                          class="d-flex align-items-center justify-content-between"
                        >
                          <div
                            class="d-flex align-items-center justify-content-center cart-price"
                          >
                            <div>
                              <span
                                class="text-bold"
                                style="font-size: 20px; color: #044b9a"
                              >
                                {{
                                  Number(
                                    getPriceData(product) *
                                      (product.quantity == 0
                                        ? 1
                                        : product.quantity)
                                  ) | currencyFilter
                                }}
                              </span>
                            </div>
                            <div style="margin-top: 3px">
                              <span
                                class="mrp-value text-grey mt-5"
                                style="
                                  font-size: 12px;
                                  text-decoration: line-through;
                                  color: #9e9e9e;
                                "
                              >
                                {{
                                  (Number(product.mrp) *
                                    (product.quantity == 0
                                      ? 1
                                      : product.quantity))
                                    | currencyFilter
                                }}
                              </span>
                            </div>
                            <div style="margin-top: 3px">
                              <span
                                class="text-price-value"
                                style="font-size: 12px; color: #108f55"
                              >
                                {{ getPercentageData(product) }}% Off
                              </span>
                            </div>
                          </div>
                          <div
                            style="
                              color: #9e9e9e;
                              font-size: 12px;
                              margin-top: 3px;
                            "
                            class="cart-unit"
                          >
                            Rs. {{ getPriceData(product) }}/Unit
                          </div>
                        </div>
                        <div :style="'color: #68696D; font-size: 12px;'">
                          <span class="cart-saving"
                            >You are saving
                            {{
                              (product.mrp *
                                (product.quantity == 0 ? 1 : product.quantity) -
                                getPriceData(product) *
                                  (product.quantity == 0
                                    ? 1
                                    : product.quantity))
                                | currencyFilter
                            }}</span
                          >
                        </div>
                        <q-separator class="my-2" />
                        <div
                          class="d-flex align-items-center justify-content-between flex-wrap gap-6"
                        >
                          <div
                            class="d-flex align-items-center gap-6 card-btns"
                          >
                            <div>
                              <q-btn
                                flat
                                @click.stop="decreaseQuantity(product)"
                                class="pd-btn minus-grid"
                                :disabled="product.quantity === 0"
                                icon="remove"
                              />
                            </div>

                            <div>
                              <input
                                v-model="product.quantity"
                                @input="handleInput(product)"
                                class="square-grid"
                                :min="0"
                                :max="product.maxPurchaseLimit"
                                @click.stop
                              />
                            </div>

                            <div>
                              <q-btn
                                flat
                                @click.stop="increaseQuantity(product)"
                                :disabled="disableIncrementButton(product)"
                                icon="add"
                                class="pd-btn plus-grid"
                              />
                            </div>
                          </div>

                          <div>
                            <q-btn
                              outline
                              @click.stop="addToCart(product)"
                              :disabled="disableAddButton(product)"
                              class="add-cart custom-outline-btn"
                            >
                              Add To Cart
                            </q-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="product.tag?.toLowerCase() === 'most popular'"
                    class="overlay-text-grid"
                  >
                    Most Popular
                  </div>

                  <div
                    v-if="
                      inBagQuantity(product) > 0 ||
                      warningMaxLimit(product) ||
                      (product.quantity > product.maxPurchaseLimit &&
                        !warningMaxLimit(product))
                    "
                    class="warning-icon"
                  >
                    <img
                      src="/info_icon.png"
                      style="
                        filter: hue-rotate(0deg) saturate(3) brightness(0.8);
                      "
                    />
                    <q-tooltip class="bg-red text-white">
                      <template v-if="inBagQuantity(product) > 0">
                        - Already added {{ inBagQuantity(product) }} Quantity in
                        Bag for this Product.
                      </template>
                      <template v-else-if="warningMaxLimit(product)">
                        {{ warningMaxLimit(product) }}
                      </template>
                      <template
                        v-else-if="
                          product.quantity > product.maxPurchaseLimit &&
                          !warningMaxLimit(product)
                        "
                      >
                        - Please Add {{ product.maxPurchaseLimit }} or Less
                        Quantities for this Product.
                      </template>
                    </q-tooltip>
                  </div>
                </q-card>
              </div>
            </div>
            <div v-if="isLoading" class="row justify-center q-my-md">
              <q-spinner-dots color="primary" size="40px" />
            </div>
          </div>
        </div>

        <div
          v-if="cartData.length > 0"
          :class="cartData.length > 0 ? 'flex-shrink-1 cart-summary-sticky' : ''"
        >
          <q-card
            v-if="cartData.length > 0"
            class="mb-3 mt-4 cart-summary-grid"
          >
            <div class="text-center p-3" :style="'background: #044b9a1a'">
              <span
                class="text-bold font-family mt-2"
                :style="'font-size:22px; color: #044B9A'"
                >Cart Summary</span
              >
            </div>
            <q-card-section
              v-if="cartData.length > 0"
              :style="'background: #044b9a1a'"
            >
              <div>
                <div class="">
                  <div class="d-flex mt-2 justify-between mx-2">
                    <h6 class="font-family font-text-size-grid">Order Total</h6>
                    <h6
                      class="font-text-size-grid"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ (payableTotal + savingTotal) | currencyFilter }}
                    </h6>
                  </div>
                  <q-separator class="my-2" />
                  <div class="d-flex mt-2 justify-between mx-2">
                    <h6 class="font-family font-text-size-grid">
                      Your Savings
                      <span
                        class="font-text-size-grid text-bold"
                        :style="'color: #388E3C;'"
                        >({{ savingPercentage }}%)</span
                      >
                    </h6>
                    <h6
                      class="font-text-size-grid"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ savingTotal | currencyFilter }}
                    </h6>
                  </div>
                  <q-separator class="my-2" />
                  <div class="d-flex mt-2 justify-between mx-2">
                    <h6 class="font-family font-text-size-grid">
                      Order Amount
                    </h6>
                    <h6
                      class="font-text-size-grid"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ payableTotal | currencyFilter }}
                    </h6>
                  </div>
                  <q-separator class="my-2" />
                  <div
                    v-if="gstColumn"
                    class="d-flex mt-2 justify-between mx-2"
                  >
                    <h6 class="font-family font-text-size-grid">
                      SGST Amount <span class="font-text-size-grid">(9%)</span>
                    </h6>
                    <h6
                      class="font-text-size-grid"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ gstCount("sgst") | currencyFilter }}
                    </h6>
                  </div>
                  <div
                    v-if="gstColumn"
                    class="d-flex mt-2 justify-between mx-2"
                  >
                    <h6 class="font-family font-text-size-grid">
                      CGST Amount <span class="font-text-size-grid">(9%)</span>
                    </h6>
                    <h6
                      class="font-text-size-grid"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ gstCount("cgst") | currencyFilter }}
                    </h6>
                  </div>
                  <div
                    v-if="!gstColumn"
                    class="d-flex mt-2 justify-between mx-2"
                  >
                    <h6 class="font-family font-text-size-grid">
                      IGST Amount <span class="font-text-size-grid">(18%)</span>
                    </h6>
                    <h6
                      class="font-text-size-grid"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ gstCount("igst") | currencyFilter }}
                    </h6>
                  </div>

                  <q-separator class="my-2" />
                  <div class="d-flex mt-2 justify-between mx-2">
                    <h6 class="text-black font-text-size-grid">Total Amount</h6>
                    <h6
                      class="font-text-size-grid"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ payableTotalAmount() | currencyFilter }}
                    </h6>
                  </div>
                  <div class="d-flex mt-2 justify-between mx-2">
                    <h6 class="text-black font-text-size-grid">
                      Rounded Amount
                    </h6>
                    <h6
                      class="font-text-size-grid"
                      :style="'color: #167E85; font-size:18px'"
                    >
                      {{ sign() }} {{ roundedAmount() | currencyFilter }}
                    </h6>
                  </div>
                  <q-separator class="my-2" />
                  <div class="d-flex mt-2 justify-between mx-2">
                    <h6 class="text-black text-bold font-text-size-grid">
                      Payable Amount
                    </h6>
                    <h6
                      class="font-text-size-grid"
                      :style="'-webkit-text-stroke-width: medium; color: #167E85; font-size:18px'"
                    >
                      {{ payableAmount() | currencyFilter }}
                    </h6>
                  </div>
                  <q-separator class="my-2" />
                  <div class="mx-4 mt-4 text-center">
                    <span
                      class="font-family text-bold text-grey"
                      style="font-size: 13px"
                    >
                      *Click on “View Cart” and complete email verification and
                      payment process.
                    </span>
                  </div>
                  <div class="mt-3 text-center mx-2">
                    <q-btn
                      @click="$router.push('/Partners/Stock/Cart')"
                      class="mt-3 view-cart"
                      no-caps
                      :style="'background-color: #105992; width: 200px;'"
                    >
                      <q-img
                        :src="'/whiteBag.png'"
                        :style="'width:20px; height: 20px;'"
                      />
                      <span
                        class="ml-4 text-bold text-white font-family"
                        :style="'font-size: 18px; letter-spacing: 1px;'"
                      >
                        View Cart
                      </span>
                    </q-btn>
                  </div>
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import Constants from "../../Constants/Constant";
import {
  NetworkCommunicator,
  setHeader,
} from "../../plugins/NetworkResourceHandler";

export default {
  name: "Products",
  data: function () {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      OnlineProducts: [],
      organizationUserState: "",
      sgstAmount: 0,
      cgstAmount: 0,
      igstAmount: 0,
      productsUpdatedData: [],
      cartData: [],
      payableTotal: 0,
      savingTotal: 0,
      savingPercentage: 0,
      isHovered: false,
      offset: 0,
      limit: 10000,
      isLoading: false,
      page: 1,
      hasMoreData: true,
      viewType: "grid",
      showTooltip: false,
      tooltipAnchor: "bottom middle",
      tooltipSelf: "top middle",
      tooltipVisibility: {},
      createdmap: {
        success: "success",
        created: "Failed",
      },
    };
  },

  created() {
    this.organizationUserState =
      this.user?.organization?.address?.state?.toLowerCase();
    setHeader();
    const savedCart = localStorage.getItem("cartProducts");
    if (savedCart) {
      this.cartData = JSON.parse(savedCart);
    }
    this.calculateCartTotal(savedCart ? JSON.parse(savedCart) : []);
    this.loadData();
  },

  computed: {
    gstColumn() {
      if (this.organizationUserState == "gujarat") {
        return true;
      } else {
        return false;
      }
    },
    groupedProducts() {
      const grouped = this.OnlineProducts.reduce((acc, product) => {
        if (!acc[product.productLineName]) {
          acc[product.productLineName] = [];
        }
        acc[product.productLineName].push(product);
        return acc;
      }, {});

      return Object.keys(grouped).map((key) => ({
        productLineName: key,
        products: grouped[key],
      }));
    },
  },

  watch: {
    OnlineProducts: {
      handler(newVal) {
        this.OnlineProducts = newVal;
      },
    },
    "$route.query.viewType": {
      immediate: true,
      handler(newVal) {
        this.viewType = newVal || "grid";
      },
    },
  },

  methods: {
    getListIconSrc() {
      return this.viewType === "list"
        ? "/List_White.png"
        : "/List_Blue.png";
    },
    getGridIconSrc() {
      return this.viewType === "grid"
        ? "/Grid_White.png"
        : "/Grid_Blue.png";
    },
    showTooltipData(productId) {
      this.tooltipVisibility = true;
    },

    hideTooltip(productId) {
      this.tooltipVisibility = false;
    },

    gstCount(type) {
      if (type == "sgst" || type == "cgst") {
        const count = (this.payableTotal * 9) / 100;
        this.sgstAmount = count;
        this.cgstAmount = count;
        return count;
      } else {
        const igstCount = (this.payableTotal * 18) / 100;
        this.igstAmount = igstCount;
        return igstCount;
      }
    },

    getViewTypeClass(type) {
      return this.viewType === type ? "btn-active" : "btn-inactive";
    },

    roundedAmount() {
      const difference = (
        this.payableAmount() - this.payableTotalAmount()
      ).toFixed(2);
      const value = Math.abs(difference);
      return value;
    },

    sign() {
      const value = (this.payableAmount() - this.payableTotalAmount()).toFixed(
        2
      );
      if (value >= 0) {
        return "+";
      } else {
        return "-";
      }
    },

    payableTotalAmount() {
      if (this.organizationUserState == "gujarat") {
        const sum = this.payableTotal + this.sgstAmount + this.cgstAmount;
        return sum;
      } else {
        const sum = this.payableTotal + this.igstAmount;
        return sum;
      }
    },

    payableAmount() {
      if (this.organizationUserState == "gujarat") {
        const sum = this.payableTotal + this.sgstAmount + this.cgstAmount;
        const value = this.roundedValue(sum);
        return value;
      } else {
        const sum = this.payableTotal + this.igstAmount;
        const value = this.roundedValue(sum);
        return value;
      }
    },

    roundedValue(value) {
      if (value % 1 >= 0.5) {
        return Math.ceil(value);
      } else {
        return Math.floor(value);
      }
    },

    handleInput(product) {
      const remainingQuantity =
        product.maxPurchaseLimit - this.inBagQuantity(product);
      if (product.quantity < 0) {
        product.quantity = 0;
      } else if (product.quantity > remainingQuantity) {
        product.quantity = remainingQuantity;
        if (this.inBagQuantity(product) === 0) {
          this.$q.notify({
            position: "top-right",
            message: `You can buy maximum ${product.maxPurchaseLimit} quantities. Only ${product.maxPurchaseLimit} items left.`,
          });
        } else if (product.maxPurchaseLimit === this.inBagQuantity(product)) {
          this.$q.notify({
            position: "top-right",
            message: `You already added the maximum quantity of this product. You can't add more.`,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            message: `You can add up to ${remainingQuantity} ${
              remainingQuantity > 1 ? "quantities" : "quantity"
            } because you already added ${this.inBagQuantity(product)} ${
              this.inBagQuantity(product) > 1 ? "quantities" : "quantity"
            } in the bag.`,
          });
        }
      }

      product.quantity = Math.max(
        0,
        parseInt(product.quantity ? product.quantity : 0, 10)
      );
    },

    calculateCartTotal(products) {
      const totalAmount = products.reduce((total, product) => {
        return total + this.calculateProductTotal(product);
      }, 0);
      this.payableTotal = totalAmount;

      const totalSavingAmount = products.reduce((total, product) => {
        return total + this.calculateProductSavingTotal(product);
      }, 0);
      this.savingTotal = totalSavingAmount;

      const savingPercentage =
        (100 * Number(this.savingTotal)) /
        (Number(this.payableTotal) + Number(this.savingTotal));
      this.savingPercentage = isNaN(savingPercentage)
        ? 0
        : savingPercentage.toFixed(0);
    },

    calculateProductTotal(product) {
      const pricing = product.pricing.find(
        (price) =>
          product.quantity >= price.qtyFrom && product.quantity <= price.qtyUpTo
      );

      if (pricing) {
        return Number(product.quantity) * Number(pricing.price);
      } else {
        const lowestPrice = product.pricing.reduce((minPrice, currentPrice) => {
          const price = parseInt(currentPrice.price);
          return price < minPrice ? price : minPrice;
        }, Infinity);
        const priceData = Number(lowestPrice) * Number(product.quantity);
        return priceData;
      }
    },

    calculateProductSavingTotal(product) {
      const savingTotal =
        Number(product.mrp) * Number(product.quantity) -
        this.calculateProductTotal(product);
      return savingTotal;
    },

    imageUrl(image) {
      const url = Constants.base_url + image;
      return url;
    },

    openOrderDetail(product) {
      this.$router.push({
        path: `/Partners/Stock/ProductDetails/`,
        query: { productId: product.id, viewType: this.viewType },
      });
    },

    inBagQuantity(product) {
      const existingProductIndex = this.cartData.findIndex(
        (item) => item.id === product.id
      );
      if (existingProductIndex !== -1) {
        return this.cartData[existingProductIndex].quantity;
      }
      return 0;
    },

    disableAddButton(product) {
      if (
        Number(product.quantity) == 0 ||
        Number(product.quantity) > Number(product.maxPurchaseLimit)
      ) {
        return true;
      } else {
        const existingProductIndex = this.cartData.findIndex(
          (item) => item.id === product.id
        );
        if (existingProductIndex !== -1) {
          const existProduct = this.cartData[existingProductIndex];
          if (
            Number(existProduct.quantity) + Number(product.quantity) >
            Number(product.maxPurchaseLimit)
          ) {
            return true;
          }
        }
      }
      return false;
    },

    disableIncrementButton(product) {
      if (Number(product.quantity) >= Number(product.maxPurchaseLimit)) {
        return true;
      } else {
        const existingProductIndex = this.cartData.findIndex(
          (item) => item.id === product.id
        );
        if (existingProductIndex !== -1) {
          const existProduct = this.cartData[existingProductIndex];
          if (
            Number(existProduct.quantity) + Number(product.quantity) >=
            Number(product.maxPurchaseLimit)
          ) {
            return true;
          }
        }
        return false;
      }
    },

    warningMaxLimit(product) {
      const foundProduct = this.cartData.find((c) => c.id === product.id);
      if (
        foundProduct &&
        product.quantity > product.maxPurchaseLimit - foundProduct.quantity
      ) {
        if (product.maxPurchaseLimit - foundProduct.quantity == 0) {
          return `- You already added maximum quantity of this Product. You can't add more.`;
        }
        return `- Please add ${
          product.maxPurchaseLimit - foundProduct.quantity
        } or less quantities for this Product.`;
      } else {
        return null;
      }
    },

    decreaseQuantity(product) {
      if (product.quantity) {
        const updatedQuantity = Number(product.quantity) - 1;
        const updatedProducts = this.OnlineProducts.map((item) => {
          if (item.id === product.id) {
            return { ...item, quantity: updatedQuantity };
          }
          return item;
        });
        this.OnlineProducts = updatedProducts;
        // this.$forceUpdate()
      }
    },

    increaseQuantity(product) {
      try {
        let updatedQuantity = 0;
        if (Number(product.quantity)) {
          updatedQuantity = Number(product.quantity) + 1;
        } else {
          updatedQuantity = 1;
        }

        const updatedProducts = this.OnlineProducts.map((item) => {
          if (item.id === product.id) {
            return { ...item, quantity: updatedQuantity };
          }
          return item;
        });
        this.OnlineProducts = updatedProducts;
      } catch (error) {
        console.error("increaseQuantity", error);
      }
    },

    addToCart(product) {
      const productCopy = { ...product };
      const existingProductIndex = this.cartData.findIndex(
        (item) => item.id === product.id
      );
      if (existingProductIndex !== -1) {
        this.cartData[existingProductIndex].quantity += Number(
          product.quantity
        );
      } else {
        productCopy.quantity = Number(product.quantity);
        this.cartData.push(productCopy);
      }

      this.OnlineProducts = this.OnlineProducts.map((item) => {
        if (item.id === product.id) {
          return { ...item, quantity: 0 };
        }
        return item;
      });
      localStorage.setItem("cartProducts", JSON.stringify(this.cartData));
      this.calculateCartTotal(this.cartData);

      this.$q.notify({
        position: "top-right",
        message: `Product added to the cart successfully!`,
      });
    },

    getPriceData(product) {
      try {
        const pricingObject = product.pricing.find((pricing) => {
          const qtyFrom = parseInt(pricing.qtyFrom);
          const qtyUpTo = parseInt(pricing.qtyUpTo);
          if (product.quantity == 0) {
            return 1 >= qtyFrom && 1 <= qtyUpTo;
          } else {
            return product.quantity >= qtyFrom && product.quantity <= qtyUpTo;
          }
        });

        if (pricingObject) {
          return pricingObject.price;
        } else {
          const lowestPrice = product.pricing.reduce(
            (minPrice, currentPrice) => {
              const price = parseInt(currentPrice.price);
              return price < minPrice ? price : minPrice;
            },
            Infinity
          );
          return lowestPrice;
        }
      } catch (error) {
        console.error("Error fetching online products data", error);
      }
    },

    getPercentageData(product) {
      const price = this.getPriceData(product);
      const result = 100 - (price * 100) / product.mrp;
      return result.toFixed(0);
    },

    async loadData() {
      try {
        if (this.isLoading || !this.hasMoreData) return;
        this.isLoading = true;
        const apiUrl = Constants.api_url + "getCurrentStock";
        const request = {
          offset: (this.page - 1) * this.limit,
          limit: this.limit,
        };
        // const response = await NetworkCommunicator('POST', apiUrl, false, request);
        const response = await NetworkCommunicator(
          "POST",
          apiUrl,
          false,
          request
        );
        const products = response.data;
        const newItems = products.map((product) => ({
          ...product,
          quantity: 0,
        }));

        if (newItems.length > 0) {
          this.OnlineProducts = [...this.OnlineProducts, ...newItems];
        } else {
          this.hasMoreData = false;
        }
      } catch (error) {
        console.error("Error fetching online products data", error);
      } finally {
        this.isLoading = false;
      }
    },

    handleScroll: _.debounce(function () {
      const { scrollTop, scrollHeight } =
        this.$refs.myScrollArea.getScrollTarget();
      const clientHeight = this.$refs.myScrollArea.$el.clientHeight;

      if (
        scrollTop + clientHeight >= scrollHeight - 200 &&
        !this.isLoading &&
        this.hasMoreData
      ) {
        this.page++;
        this.loadData();
      }
    }, 300),
  },
};
</script>

<style scoped>
.square {
  border: 1px solid #000;
  padding: 6px 12px 6px 12px;
  display: inline-block;
  background-color: white;
}

.text-price-value {
  color: #167e85;
}

.icon-img-set {
  margin: 0 014px 0 5px;
}

.shop_card {
  position: relative;
}

.card_number {
  position: absolute;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background-color: #f16565;
  top: -4px;
  right: -5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 10px;
  padding-top: 1px;
}

.icon_hover {
  height: 38px;
  width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-left: 18px;
}

.icon_hover:hover {
  background-color: #ebebeb;
}

.font-family {
  font-family: avenirRegular;
}

.font-text-size {
  font-size: 14px;
}

.font-text-size-grid {
  font-size: 14px;
}

.product-image-size {
  width: 150px;
  max-width: 150px;
}

.cardap-contents {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 30px;
}

.cart-items {
  display: grid;
  align-items: center;
  gap: 24px;
}

.gap-6 {
  gap: 6px;
}

.square-list {
  left: 3px;
  height: 27px;
  text-align: center;
  width: 38px;
  color: #167e85;
  border: none;
  outline: none;
  font-size: larger;
  margin-left: -5px;
  font-weight: bold;
  position: relative;
  margin-top: 3px;
}

.square-grid {
  left: 3px;
  height: 27px;
  text-align: center;
  width: 38px;
  color: #167e85;
  border: none;
  outline: none;
  font-size: larger;
  margin-left: -5px;
  font-weight: bold;
  position: relative;
}

.plus-grid {
  height: 35px;
  width: 34px;
  color: #1e1f3d80 !important;
  background-color: transparent !important;
  border: 1px solid #1e1f3d4d !important;
  border-radius: 5px;
  margin-left: 0px;
  font-size: larger;
}

.minus-grid {
  height: 35px;
  width: 34px;
  color: #1e1f3d80 !important;
  background-color: transparent !important;
  border: 1px solid #1e1f3d4d !important;
  border-radius: 5px;
  font-size: larger;
}

.add-cart {
  height: 35px;
  text-transform: none;
  font-size: 14px;
  margin-left: 0px;
  border: solid #167e85 !important;
}

@media only screen and (max-width: 1100px) {
  .main-container {
    max-width: 940px;
    margin: 0 auto;
  }

  .product-container {
    max-width: 1024px;
    margin: 0 auto;
  }

  .main-image-set {
    margin-right: 25px;
  }

  .view-cart {
    height: 40px;
  }
}

@media only screen and (min-width: 1101px) and (max-width: 1280px) {
  .main-container {
    max-width: 1024px;
    margin: 0 auto;
  }

  .product-container {
    max-width: 1024px;
    margin: 0 auto;
  }

  .main-image-set {
    margin-right: 55px;
  }

  .view-cart {
    height: 40px;
  }
  .q-btn-toggle-view {
    margin-right: 8px;
  }

  .cart-items {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

@media only screen and (min-width: 1281px) and (max-width: 1780px) {
  .main-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .product-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .main-image-set {
    margin-right: 75px;
  }

  .view-cart {
    height: 40px;
  }

  .cart-items {
    grid-template-columns: repeat(3, 1fr) !important;
  }
}

@media only screen and (min-width: 1781px) {
  .main-container {
    max-width: 1570px;
    margin: 0 auto;
  }

  .product-container {
    max-width: 1280px;
    margin: 0 auto;
  }

  .cart-items {
    grid-template-columns: repeat(4, 1fr);
  }

  .main-image-set {
    margin-right: 90px;
  }

  .view-cart {
    height: 60px;
  }
}

.overlay-text {
  position: absolute;
  bottom: 16px;
  left: 1px;
  background-color: #f16565;
  color: white;
  padding: 5px;
  font-size: 1em;
  border-radius: 1px;
  opacity: 90%;
}

.overlay-text-grid {
  position: absolute !important;
  top: 0px;
  left: 0px;
  background-color: #ffc9c9;
  color: #9a0404;
  padding: 5px;
  font-size: 1em;
  font-weight: bold;
  border-radius: 18px 0px 18px !important;
  height: 32px;
  opacity: 90%;
}

.warning-icon {
  position: absolute !important;
  top: 0px;
  right: 0px;
  background-color: white;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
  font-size: 1em;
  border-radius: 50% !important;
}

.align-items-center {
  align-items: center;
}

.image-container {
  height: 140px;
  width: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: cover;
  overflow: hidden;
  background: #e7eff2 !important;
}

.image-container img {
  max-width: 100%;
  max-height: 90%;
  object-fit: cover;
}

.image-container-grid {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: cover;
  overflow: hidden;
  background: #e7eff2 !important;
  border-radius: 8px;
}

.image-container-grid img {
  max-width: 100%;
  max-height: 90%;
  padding: 1px;
}

.q-scrollarea__content.absolute {
  position: static !important;
}

.my-cart {
  border-radius: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative !important;
  width: 270px;
  box-shadow: none;
}

.flex-shrink-1 {
  flex-shrink: 1;
}

.btn-active {
  background-color: #044b9a !important;
  color: white !important;
  text-transform: none;
  width: 78px;
  padding-right: 12px;
}

.cart-price {
  gap: 7px;
}

.btn-inactive {
  background-color: #e4ecf2 !important;
  color: #044b9a !important;
  width: 78px;
  text-transform: none;
  padding-right: 15px;
}

.cart-unit {
  font-size: 13px;
}

.flex-column {
  flex-direction: column;
}

.large-tooltip {
  max-width: 500px !important;
  width: 400px !important;
}

.list-img {
  margin-left: -45px;
  margin-top: 6px;
}

.grid-img {
  margin-left: -50px;
  margin-top: 8px;
}

.custom-outline-btn {
  color: #167e85 !important;
  border: #167e85 !important;
}

.custom-outline-btn:hover {
  background-color: #167e85 !important;
  color: #ffffff !important;
}

.grid-layout {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  justify-content: space-between;
  position: relative;
}

.list-contents {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  width: 109%;
}

.grid-contents {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
}

.flex-grow {
  flex-grow: 1;
}

.view-cart {
  height: 50px;
}

.view-cart-list {
  height: 50px;
}

.product-group {
  background: #e7eff2;
  padding: 20px;
  border-radius: 15px;
  width: 100%;
}

.product-group-grid {
  background: #e7eff2;
  padding: 20px;
  border-radius: 15px;
  width: 100%;
}

.cart-summary-sticky {
  position: sticky;
  top: 70px;
}

.list-btn {
  border-radius: 0px 10px 10px 0px;
  width: 80px;
  padding: 0px;
  padding-right: 0px;
}

.grid-btn {
  border-radius: 10px 0px 0px 10px;
  height: 39px;
}

.cart-summary,
.cart-summary-grid {
  position: sticky;
  top: 0;
  z-index: 1;
  box-shadow: none;
  border-radius: 15px;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
</style>
